import React, { useEffect, useState } from 'react';
import './index.less';
import { Button, Card, Form, FormInstance, Input, Select, Spin,Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import IF from '@/components/IF';
import { getLocationByNameOrCoordinate } from '@/util/Request/agrialert';
import { getLocationByNameOrCoordinateResModel, locationListModel } from '@/util/Request/agrialert/requestType';
import { TemplateEnumType } from '@/util/Request/agrialert/responseType';
import {debounce} from '@/util/commonFunction';
import TextArea from 'antd/lib/input/TextArea';

interface Iprop{
    isDisabled: boolean;
    form: FormInstance;
    selectedTemplateType: TemplateEnumType;
    locationList: locationListModel[];
    templateId?: number;
    locationCheckFlag: boolean;
    changeLocationCheckFlag: (flag: boolean) => void
    changeLocationListCallback: (tmpLocationList:locationListModel[])=>void
}

const AgriAlertLocation = (prop: Iprop)=>{

    const {
        isDisabled,
        form,
        selectedTemplateType,
        locationList,
        templateId,
        locationCheckFlag,
        changeLocationCheckFlag,
        changeLocationListCallback
    } = prop;

    const [searchText, setSearchText] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const [searchLocationInformations, setSearchLocationInformations] = useState<getLocationByNameOrCoordinateResModel[]>([]);
    const [currentIndex,setCurrentIndex] = useState(null);
    const [currentCheckEmailIndexList,setCurentCheckEmailIndexList] = useState<number[]>([]);
    const [currentCheckEmailRepeatIndexList,setCurentCheckEmailRepatIndexList] = useState<number[]>([]);
    const [currentCheckLatLngIndexList,setCurentCheckLatLngIndexList] = useState<number[]>([]);

    // const [form] = Form.useForm();
    const filterOption = (inputValue: string, option: any): boolean => {
        if (containsComma(inputValue)) {
            return option.children;
        }else
            return option?.children?.toLowerCase().includes(inputValue?.toLowerCase());
    };
    const containsComma = (inputValue: string): boolean => {
        return inputValue.includes(',');
    };

    const handleChangeForLocation = (placeId,index) => {
        const results = searchLocationInformations.find((tz) => tz.placeId === placeId);
        const locationListModel={
            locationName: results.adminName,
            lat: results.latitude,
            lng: results.latitude,
            toUserEmail: '',
            sortNumber: index
        };
        let existFlag = false;
        const tmpLocationList = locationList.map((item,itemIndex)=>{
            if(item.sortNumber === index){
                existFlag = true;
                return{
                    ...item,
                    lat : results?.latitude,
                    lng : results?.longitude,
                    locationName : results?.adminName,
                };
            }
            else{
                return {...item};
            }
        });
        if(existFlag === false){
            tmpLocationList.push(locationListModel);
        }
        // =======   check current location and email whether repeat ===========
        let tmpCheckEmailRepeatIndexList = [...currentCheckEmailRepeatIndexList];
        const tmpCurrentLocationEmail = tmpLocationList.find( x => x.sortNumber === index)?.toUserEmail;
        // const tmpOriginLocationList:locationListModel[] = JSON.parse(JSON.stringify(locationList)) as locationListModel[];
        const tmpRepeatLocation = tmpLocationList?.filter( x => x.locationName === results?.adminName && x.sortNumber !== index);
        let repeatExistFlag = false;
        if(tmpRepeatLocation?.length >= 1){
            // mean location name is repeat, should check email whether repeat
            if(tmpRepeatLocation?.[0]?.toUserEmail === tmpCurrentLocationEmail){
                // mean location and eamil is repeat
                const flag = tmpCheckEmailRepeatIndexList.find( x => x === index);
                if(flag){
                    console.log('current index is exist');
                }
                else{
                    tmpCheckEmailRepeatIndexList.push(index);
                }
                repeatExistFlag = true;
            }
        }
        if(!repeatExistFlag){
            const tmp = currentCheckEmailRepeatIndexList.filter( x=> x!= index);
            tmpCheckEmailRepeatIndexList = [...tmp];
        }
        setCurentCheckEmailRepatIndexList(tmpCheckEmailRepeatIndexList);
        // =======   check current location and email whether repeat ===========
        changeLocationListCallback(tmpLocationList);
        setCurrentIndex(null);
    };
    const searchLocationAction = async (text: string) => {
        if (text.trim()) {
            setLoading(true);
            try {
                const response = await getLocationByNameOrCoordinate(text.trim());
                setSearchLocationInformations(response.data);
            } finally {
                setLoading(false);
            }
        }
    };
    const handleSearch = debounce((value:string,index:number)=>{
        console.log('lanxue check search',value);
        console.log('lanxue check search value',isFirstTwoDigitsNumber(value));
        if(!value) return;
        if(isFirstTwoDigitsNumber(value)){
            handleChangeForLocationForLat(value,index);
            setSearchLocationInformations([]);
        }
        else{
            const tmp = debounce((value)=>{
                setSearchText(value);
                searchLocationAction(value);
            },500);
            tmp(value);
            removeInValidLatLngIndex(index);
        }

    },500);

    const removeInValidLatLngIndex = (index:number)=>{
        let tmpCheckLatLngIndexList = [...currentCheckLatLngIndexList];
        const flag = currentCheckLatLngIndexList.filter(x => x === index);
        if(flag?.length >= 1){
            const tmp = currentCheckLatLngIndexList.filter( x => x !== index);
            tmpCheckLatLngIndexList = [...tmp];
        }
        else{
            console.log();
        }
        setCurentCheckLatLngIndexList(tmpCheckLatLngIndexList);
    };
    const isFirstTwoDigitsNumber = (str:string) =>{
        if(Number(str) || Number(str) === 0){
            return true;
        }
        else{
            const tmpStr = str?.split(',');
            if(Number(tmpStr[0]) || Number(tmpStr[0]) === 0) return true;
            else return false;
        }
    };
    const handleChangeForLocationForLat = (inputLngAndLat:string,index:number) => {
        // const results = searchLocationInformations.find((tz) => tz.placeId === placeId);
        const results = inputLngAndLat?.split(',');
        const locationListModel={
            locationName: inputLngAndLat,
            lat: Number(results?.[1]),
            lng: Number(results?.[0]),
            toUserEmail: '',
            sortNumber: index
        };
        // const tmpLocationList = [...locationList];
        let existFlag = false;
        const tmpLocationList = locationList.map((item,itemIndex)=>{
            if(item.sortNumber === index){
                existFlag = true;
                return{
                    ...item,
                    locationName: inputLngAndLat,
                    lat: Number(results?.[1]),
                    lng: Number(results?.[0]),
                };
            }
            else{
                return {...item};
            }
        });
        if(existFlag === false){
            tmpLocationList.push(locationListModel);
        }
        changeLocationListCallback(tmpLocationList);
        let tmpCheckLatLngIndexList = [...currentCheckLatLngIndexList];
        if((Number(results?.[1]) >= -90 && Number(results?.[1]) <= 90) &&
            (Number(results?.[0]) >= -180 && Number(results?.[0]) <= 180)
        ){
            const flag = currentCheckLatLngIndexList.filter(x => x === index);
            if(flag?.length >= 1){
                const tmp = currentCheckLatLngIndexList.filter( x => x !== index);
                tmpCheckLatLngIndexList = [...tmp];
            }
            else{
                console.log();
            }
        }
        else{
            const flag = currentCheckLatLngIndexList.filter(x => x === index);
            if(flag?.length >= 1){
                console.log();
            }
            else{
                tmpCheckLatLngIndexList.push(index);
            }
        }
        setCurentCheckLatLngIndexList(tmpCheckLatLngIndexList);
    };

    const onChangeForTo = debounce((value,index) => {
        const tmpOriginLocationList:locationListModel[] = JSON.parse(JSON.stringify(locationList)) as locationListModel[];
        const tmpLocationList = locationList.map((item,itemIndex)=>{
            if(item.sortNumber === index){
                return{
                    ...item,
                    toUserEmail:value
                };
            }
            else{
                return{...item};
            }
        });
        changeLocationListCallback(tmpLocationList);
        let tmpCheckEmilaIndexList = [...currentCheckEmailIndexList];
        let tmpCheckEmailRepeatIndexList = [...currentCheckEmailRepeatIndexList];
        // if value is true, mean emial is valid, not show error message
        if(checkEmails(value)){
            const flag = currentCheckEmailIndexList.filter(x => x === index);
            if(flag?.length >= 1){
                const tmp = currentCheckEmailIndexList.filter( x => x !== index);
                tmpCheckEmilaIndexList = [...tmp];
            }
            else{
                console.log();
            }
            // when value is valid, should check whether location and email is repeat
            console.log('lanxue repeat');
            const tmpNameVaue = tmpOriginLocationList.filter( x => x.toUserEmail === value);
            if(tmpNameVaue?.length >= 1){
                // mean name have repeat, should check locationName, is locationName is repeat, should shou error message
                const tmpLocatinName = tmpOriginLocationList.filter( x => x.sortNumber === index)[0]?.locationName;
                if(tmpLocatinName === tmpNameVaue[0]?.locationName){
                    // mean name repeat
                    // if is already exist
                    const repeatFlat = currentCheckEmailRepeatIndexList.filter( x => x=== index);
                    if(repeatFlat?.length >= 1){
                        console.log('alread exist');
                    }
                    else{
                        tmpCheckEmailRepeatIndexList.push(index);
                    }
                }
            }
            else{
                // mean name not repat,
                const repeatFlag = currentCheckEmailRepeatIndexList.filter( x => x === index);
                if(repeatFlag?.length >= 1){
                    const tmp = currentCheckEmailRepeatIndexList.filter(x => x !== index);
                    tmpCheckEmailRepeatIndexList = [...tmp];
                }

            }
        }else{
            const flag = currentCheckEmailIndexList.filter(x => x === index);
            if(flag?.length >= 1){
                console.log();
            }
            else{
                tmpCheckEmilaIndexList.push(index);
            }
        }
        setCurentCheckEmailIndexList(tmpCheckEmilaIndexList);
        setCurentCheckEmailRepatIndexList(tmpCheckEmailRepeatIndexList);
    },1);
    const onChangeForFrom = debounce((value,index) => {
        const tmpOriginLocationList:locationListModel[] = JSON.parse(JSON.stringify(locationList)) as locationListModel[];
        // const tmpFrom = value.replace(/^([^@]+)@.*/, (match, p1) => `${p1}@cehub.syngenta.com`);
        const tmpFrom = value?.trim()?.replace(/^([^@]+)@.*/, (match, p1) => `${p1}`);
        const tmpLocationList = tmpOriginLocationList.map((item,itemIndex)=>{
            if(item.sortNumber === index){
                return{
                    ...item,
                    fromEmail:tmpFrom
                };
            }
            else{
                return{...item};
            }
        });
        changeLocationListCallback(tmpLocationList);
    },1);
    function isValidEmail(email: string) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    function checkEmails(emailsString: string): boolean {
        const emails = emailsString?.split(';');
        for (const email of emails) {
            // Remove whitespace characters
            const trimmedEmail = email.trim();
            // Check if it is an empty string
            if (trimmedEmail === '') continue;
            // Check if it is a valid email
            if (!isValidEmail(trimmedEmail)) {
                return false; // Find an invalid one and return false
            }
        }
        return true;
    }
    useEffect(()=>{
        if(locationList?.length >= 1){
            // const tmpLocationList = [...locationList];
            const tmpLocationList:locationListModel[] = JSON.parse(JSON.stringify(locationList)) as locationListModel[];
            for(let i = 0; i < tmpLocationList?.length; i++){
                tmpLocationList[i].sortNumber = i;
            }
            form.setFieldsValue({
                ...form.getFieldsValue(),
                items: tmpLocationList
            });
        }
    },[locationList]);
    const selfAdd = ()=>{
        const tmpLocationList:locationListModel[] = [...form.getFieldValue('items')];
        tmpLocationList.push({
            locationId: 0,
            templateId: templateId,
            locationName: null,
            lat: null,
            lng: null,
            toUserEmail: '',
            sortNumber: tmpLocationList?.length,
            fromEmail: 'CEHub.dataplatform'
        });
        changeLocationListCallback(tmpLocationList);
    };

    const removeLocation = (index)=>{
        // const tmpLocationList = locationList?.filter( x => x?.sortNumber != index);
        let tmpLocationList:locationListModel[] = [];
        if(locationList?.length === 1){
            tmpLocationList.push({
                locationId: 0,
                templateId: templateId,
                locationName: null,
                lat: null,
                lng: null,
                toUserEmail: '',
                sortNumber: tmpLocationList?.length,
                fromEmail: 'CEHub.dataplatform'
            });
        }
        else if(locationList?.length > 1){
            tmpLocationList = locationList?.filter(x => x?.sortNumber !== index).map((item, newIndex) => ({
                ...item,
                sortNumber: newIndex // 重新设置 sortNumber
            }));
        }

        changeLocationListCallback(tmpLocationList);

        // 处理 currentCheckEmailIndexList 及其他相关列表
        const handleIndexLists = (list: number[] | undefined, indexToDelete: number): number[] => {
            if (!list) return [];

            // 如果 list 包含要删除的 index，则移除它
            const newList = list.filter(x => x !== indexToDelete).map(x =>
                x > indexToDelete ? x - 1 : x // 如果索引大于要删除的索引，则减一
            );

            return newList;
        };

        const tmpCurrentCheckEmailIndexList = handleIndexLists(currentCheckEmailIndexList, index);
        const tmpCurrentCheckEmailRepeatIndexList = handleIndexLists(currentCheckEmailRepeatIndexList, index);
        const tmpCurrentCheckLatLngIndexList = handleIndexLists(currentCheckLatLngIndexList, index);

        setCurentCheckEmailIndexList(tmpCurrentCheckEmailIndexList);
        setCurentCheckEmailRepatIndexList(tmpCurrentCheckEmailRepeatIndexList);
        setCurentCheckLatLngIndexList(tmpCurrentCheckLatLngIndexList);

    };

    useEffect(()=>{
        if(currentCheckEmailIndexList?.length >= 1 ||
            currentCheckEmailRepeatIndexList?.length >= 1 ||
            currentCheckLatLngIndexList?.length >= 1
        ){
            changeLocationCheckFlag(false);
        }
        else{
            changeLocationCheckFlag(true);
        }
    },[currentCheckEmailIndexList,currentCheckEmailRepeatIndexList,currentCheckLatLngIndexList]);

    return(
        <>
            <Form.List name="items">
                {(fields, { add, remove }) => (
                    <div style={{ display: 'flex', rowGap: 16, flexDirection: 'column'}}>
                        {fields.map((field,index) => {
                            return(
                                <>
                                    <Card
                                        size="small"
                                        key={field.key}
                                        // extra={ <CloseOutlined onClick={() => {remove(field.name);}}/>}>
                                        // extra={<CloseOutlined className={isDisabled?'view-close':''} onClick={() => {removeLocation(index);}}/>}
                                        extra={
                                            isDisabled ?
                                                null : <CloseOutlined className={isDisabled?'view-close':''} onClick={() => {removeLocation(index);}}/>
                                        }
                                    >
                                        <Form.Item
                                            label="Location(Long, Lat or Place Name)"
                                            labelCol={{ style: { minWidth: 250 } }}
                                            // label={
                                            //     <Tooltip title="Location: (Longitude, Latitude Or PlaceName)">
                                            //             Location:
                                            //     </Tooltip>
                                            // }
                                            name={[field.name, 'name']} required>
                                            <Spin spinning={loading}>
                                                <Select
                                                    showSearch
                                                    optionFilterProp="children"
                                                    onChange={
                                                        (value)=>{
                                                            setTimeout(()=>handleChangeForLocation(value,index),50);
                                                        }
                                                    }
                                                    onSearch={(value)=>handleSearch(value,index)}
                                                    filterOption={filterOption}
                                                    disabled={isDisabled}
                                                    notFoundContent={searchText ? 'No results found' : undefined}
                                                    placeholder="Longitude, Latitude Or PlaceName"
                                                    value = {form?.getFieldValue('items')?.[index]?.locationName}
                                                    defaultOpen={false}
                                                    onFocus={()=>{setCurrentIndex(index);}}
                                                    onBlur={()=>{setCurrentIndex(null);}}
                                                    onClick={()=>{setCurrentIndex(index);}}
                                                    open = {
                                                        (
                                                            searchLocationInformations?.length >= 1 && currentIndex === index
                                                        ) ? true : false}
                                                >
                                                    {searchLocationInformations?.map((info) => (
                                                        <Select.Option key={info.placeId} value={info.placeId}>
                                                            {info?.adminName}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                                <IF show={currentCheckLatLngIndexList?.filter(x => x===index)?.length >= 1}>
                                                    <div>
                                                        <label style={{color:'red'}}>The Longitude or Latitude you entered is invalid</label>
                                                    </div>
                                                </IF>
                                            </Spin>

                                        </Form.Item>

                                        <Form.Item label="From:" name={[field.name, 'from']} required>
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <Input
                                                    size='large'
                                                    onChange={(e)=>onChangeForFrom(e.target.value,index)}
                                                    placeholder="Default email address is CEHub.dataplatform@syngenta.com"
                                                    disabled={isDisabled}
                                                    value = {
                                                        form?.getFieldValue('items')?.[index]?.fromEmail
                                                    }
                                                    suffix='@syngenta.com'
                                                    style={{width:'auto',maxWidth:'500px'}}
                                                    // style={{width:'400px'}}
                                                    className='myInput'
                                                >
                                                </Input>
                                            </div>
                                        </Form.Item>

                                        <Form.Item label="To:" name={[field.name, 'to']} required>
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                {/* <Input
                                                    size='large'
                                                    onChange={(e)=>onChangeForTo(e.target.value,index)}
                                                    placeholder="Please enter email address,multiple email addresses should be separated by ';' "
                                                    disabled={isDisabled}
                                                    value = {
                                                        form?.getFieldValue('items')?.[index]?.toUserEmail
                                                    }
                                                >
                                                </Input> */}
                                                <TextArea
                                                    size='large'
                                                    onChange={(e)=>onChangeForTo(e.target.value,index)}
                                                    placeholder="Please enter email address,multiple email addresses should be separated by ';' "
                                                    disabled={isDisabled}
                                                    value = {
                                                        form?.getFieldValue('items')?.[index]?.toUserEmail
                                                    }

                                                >
                                                </TextArea>
                                                <IF show={currentCheckEmailIndexList?.filter(x => x===index)?.length >= 1}>
                                                    <label style={{color:'red'}}>The email address you entered is invalid</label>
                                                </IF>
                                                <IF show={currentCheckEmailRepeatIndexList?.filter(x => x===index)?.length >= 1}>
                                                    <label style={{color:'red'}}>The email address and location you entered is repeat, please input a new email</label>
                                                </IF>
                                            </div>
                                        </Form.Item>
                                    </Card>
                                </>
                            );
                        })}
                        <div className="divider-container">
                            <div className="divider"></div>
                            <Button
                                className={isDisabled?'view-button':'default-button'}
                                disabled={isDisabled}
                                onClick={() => selfAdd()} block>
                                        + Add new row
                            </Button>
                            <div className="divider"></div>
                        </div>
                    </div>
                )}
            </Form.List>
        </>
    );
};

export default React.memo(AgriAlertLocation);